export const isPreview = import.meta.env.VITE_VERCEL_ENV === 'preview'
export const isProduction = import.meta.env.VITE_VERCEL_ENV === 'production'
export const isDev = !isPreview && !isProduction
export const isDevOrPreview = isDev || isPreview
export const isApplicationClosed = false
